import { Loader2 } from 'lucide-react';
import { cn } from '@/lib/utils';

export const Loader = ({ className }: { className?: string }) => {
  return <Loader2 className={cn('my-28 size-16 animate-spin text-white/75', className)} />;
};
